import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { withApollo, compose } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'
import {
  createBanners,
  deleteBanners,
  fetchBannersList,
  updateBanners
} from '../../modules/banners'

import {
  message,
  Card,
  Table,
  Divider,
  Popconfirm,
  Button,
  Input,
  Icon,
  Tag
} from 'antd'
import moment from 'moment';
import { useDeepEffect } from '../../utils/hooks'
import _ from 'lodash'
import Highlighter from 'react-highlight-words'
import BannersForm from './components/BannersForm'

const Banners = () => {
  const dispatch = useDispatch()
  let searchInput = useRef(null)
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})
  const [searchText, setSearchText] = useState('')

  const { bannersItem, isLoading } = useSelector(
    (state) => ({
      bannersItem: state.banners.bannersList,
      isLoading: state.banners.isLoading
    }),
    []
  )

  const GetStatusColor = (status) => {
    let color = ''
    switch (status) {
      case 'Enabled':
        color = 'green'
        break
      case 'Disabled':
        color = 'red'
        break
      case 'Expired':
        color = 'purple'
        break
      default:
        break
    }
    return color
  }
  const GetDate = (time) => {
    let date = ''
    if (time !== null) {
      date = moment(time).format('DD/MM/YYYY')
    }
    return date
  }

  useDeepEffect(() => {
    async function fetch() {
      await dispatch(fetchBannersList())
    }

    fetch()
  }, [])

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}>
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select())
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  })

  const handleSearch = (selectedKeys, confirm) => {
    confirm()
    setSearchText(selectedKeys[0])
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const refetchData = async () => { }

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }
  const onCloseModal = async () => {
    await dispatch(fetchBannersList())
    await setVisible(false)
  }

  const onOk = async (data) => {
    if (!_.isEmpty(formData)) {
      await dispatch(updateBanners(data))
    } else {
      await dispatch(createBanners(data))
    }

    await dispatch(fetchBannersList())
    await setVisible(false)
    await setFormData({})
  }

  const onDelete = async (id) => {
    await dispatch(deleteBanners(id))
    await dispatch(fetchBannersList())
  }
  const columns = [
    {
      title: 'หัวข้อ',
      dataIndex: 'name',
      key: 'name',
      ...getColumnSearchProps('name'),
      render: (name, row) => (
        <div>
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={name.toString()}
          />
        </div>
      )
    },
    {
      title: 'URL',
      dataIndex: 'url',
      key: 'url',
      ...getColumnSearchProps('url'),
      render: (text, record) => {
        return <a href={record.url}>{record.url}</a>
      }
    },
    {
      title: 'Start Date',
      dataIndex: 'startDate',
      key: 'startDate',
      render: (startDate) => {
        const start = GetDate(startDate)
        return (
          <span>
            {start}
          </span>
        )
      }
    },
    {
      title: 'End Date',
      dataIndex: 'endDate',
      key: 'endDate',
      render: (endDate) => {
        const end = GetDate(endDate)
        return (
          <span>
            {end}
          </span>
        )
      }
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      filters: [
        { text: 'Enabled', value: "Enabled" },
        { text: 'Disabled', value: "Disabled" },
        { text: 'Expired', value: "Expired" }
      ],
      onFilter: (value, record) => record.status === value,
      render: (status) => {
        const color = GetStatusColor(status)
        return (
          <span>
            <Tag color={color} key={status}>
              {status}
            </Tag>
          </span>
        )
      }
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 100,
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  return (
    <Card
      title="Popup Banners"
      extra={
        <div>
          <Button size="small" icon="plus" onClick={(e) => onClick(e)}>
            Create Popup Banners
          </Button>
          <Button size="small" icon="reload" onClick={() => refetchData()}>
            Reload
          </Button>
        </div>
      }>
      <Table
        loading={isLoading}
        scroll={{ x: 1100 }}
        rowKey={(record) => record.id}
        dataSource={bannersItem}
        columns={columns}
      />
      <BannersForm
        visible={visible}
        onOk={onOk}
        onCancel={onCloseModal}
        formData={formData}
      />
    </Card>
  )
}

export default compose(
  withApollo
)(Banners)
